module.exports = __webpack_public_path__ + "static/media/mode-58.097ef255.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-58.svg
// module id = 1030
// module chunks = 2